import type { DomainManifest } from 'modules/core/lib/manifests/types'
import type { Navigation, NavigationPaths } from 'modules/core/lib/navigation/context'

import { DeleteSurveyActivity } from 'modules/trainings/activities/DeleteSurvey'
import { EditSurveySettingsActivity } from 'modules/trainings/activities/EditSurveySettings'
import { SendSurveyActivity } from 'modules/trainings/activities/SendSurvey'

export const manifest = {
  sidebar: (_navigation: Navigation<NavigationPaths>) => ({
    items: [],
  }),
  activities: {
    sendSurvey: {
      component: SendSurveyActivity,
    },
    deleteSurvey: {
      component: DeleteSurveyActivity,
    },
    editSurveySettings: {
      component: EditSurveySettingsActivity,
    },
  },
} as const satisfies DomainManifest
